import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getApiRecordLogAsync,getAccountApiRecordLogAsync,setSortConfig,updateSorting } from "./ApiRecordLogSlice";
import '../../../common/css/timeLive.css'
import { getValueFromResource } from '../../../common/timeLiveFunction';
const ApiRecordLogItem = (props: any) => {
    const {webhookreceiverlogid,t} = props;
    const dispatch = useAppDispatch();
    const { apiRecordLogList, isReload ,pageSize, totalItems, search, columnIndex, direction,pageNo,startRec, sortOrder, sortColumn, recordsFiltered, isLoading, isSort } = useAppSelector((state) => state.apiRecordLog);

    const onViewDetailClick = (AccountApiRecordLogId: string) => {
        dispatch(getApiRecordLogAsync(AccountApiRecordLogId))
            .unwrap()
            .then((originalPromiseResult) => {               
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }
    // useEffect(() => {
    //     if (isSort) {
    //         dispatch(getAccountApiRecordLogAsync());
    //     }
    // }, [isSort]);

    // const handleSort = (columnIndex: number) => {
    //     dispatch(setSortConfig({ columnIndex, direction }));
    // };
 const onHandleSorting = (sortOrder: string, sortColumn: string) => {

    let objects = {
        "sortOrder": sortOrder,
        "sortColumn": sortColumn,
        "startRec": 0,
        "pageSize": pageSize,
        "pageNo": 1
    }
    dispatch(updateSorting(objects));
}
    return (
        <>
         {/* {isLoading && (
                // <div className="spinner-overlay">
                //     <div className="spinner"></div>
                // </div>
            )}  */}
            
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                    <tr className="thHeading align-middle" >
                    <th style={{ width: '20%' }}>
                        {/* {t('Date')} */}
                        {getValueFromResource('Date',dispatch, t)}
                            {sortColumn === '0' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "0") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "0") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "0") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "0") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                            

                        <th style={{ width: '10%' }}>
                            {/* {t('Status')} */}
                            {getValueFromResource('Status',dispatch, t)}

                            {sortColumn === '1' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                            
                        <th style={{ width: '25%' }}>
                            {/* {t('Name')} */}
                            {getValueFromResource('Name',dispatch, t)}
                            {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                            
                        <th style={{ width: '10%' }}>
                            {/* {t('Method')} */}
                            {getValueFromResource('Method',dispatch, t)}
                            {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                            
                        <th style={{ width: '10%' }}>
                            {/* {t('Coming From')} */}
                            {getValueFromResource('Coming From',dispatch, t)}
                            {sortColumn === '4' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                             
                        <th style={{ width: '15%' }}>
                            {/* {t('User Agent')} */}
                            {getValueFromResource('User Agent',dispatch, t)}
                            {sortColumn === '5' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                            
                                                       
                            <th className='col-1 text-center'></th>
                        </tr>
                    </thead>
                    <tbody>
                  
                        {apiRecordLogList.length === 0 && <tr><td colSpan={6}><p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}

                            </p></td></tr>}
                        {apiRecordLogList.length > 0 && apiRecordLogList.map((apiRecordLogDetail: any, i: any) => (
                            <tr key={i}>                                
                                <td>
                                    <span className="d-block">
                                        {apiRecordLogDetail.ActionDate}
                                    </span>
                                </td>
                                <td>
                                    {(apiRecordLogDetail.ActionStatus === 'Fail' || apiRecordLogDetail.ActionStatus === 'fail' ) ?  
                                        <span className="badge badge-light-danger  fs-7">{apiRecordLogDetail.ActionStatus}</span> : 
                                        <span className="badge badge-light-success fs-7">{apiRecordLogDetail.ActionStatus}</span> 
                                    }
                                </td>
                                <td  id="kt_OffCanvas"  style={{ cursor: 'pointer' }} className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={() => { onViewDetailClick(apiRecordLogDetail.AccountApiRecordLogId) }}
                                >
                                <span  className="d-block"> {apiRecordLogDetail.SystemApiName}</span>
                            </td>
                                <td>
                                    <span  className="d-block">
                                        {apiRecordLogDetail.SystemActionTypeName}
                                    </span>
                                </td>
                                <td>
                                    <span  className="d-block">
                                        {apiRecordLogDetail.RequestComingFrom}
                                    </span>
                                </td>
                                <td>
                                 <span  className="d-block">
                                        {apiRecordLogDetail.UserAgent}
                                    </span>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center flex-shrink-0'>
                                        <a id="kt_OffCanvas" className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            onClick={() => { onViewDetailClick(apiRecordLogDetail.AccountApiRecordLogId) }}>
                                            
                                            <i className="bi bi-receipt fs-3"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        ))} 
                    </tbody>
                </table>
        </>
    )
}

export default ApiRecordLogItem
